/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DeliveryItemV2Response', 'model/FlowRequest', 'model/FlowResponse', 'model/IInvoiceItemV2Response', 'model/PartResponse', 'model/ProductResponse', 'model/WorkItemV2Response', 'model/WorkV2Response'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./DeliveryItemV2Response'), require('./FlowRequest'), require('./FlowResponse'), require('./IInvoiceItemV2Response'), require('./PartResponse'), require('./ProductResponse'), require('./WorkItemV2Response'), require('./WorkV2Response'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.DeliveryItemV2Response = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.DeliveryItemV2Response, root.BpmbuildDevelopmentappspotcom.FlowRequest, root.BpmbuildDevelopmentappspotcom.FlowResponse, root.BpmbuildDevelopmentappspotcom.IInvoiceItemV2Response, root.BpmbuildDevelopmentappspotcom.PartResponse, root.BpmbuildDevelopmentappspotcom.ProductResponse, root.BpmbuildDevelopmentappspotcom.WorkItemV2Response, root.BpmbuildDevelopmentappspotcom.WorkV2Response);
  }
}(this, function(ApiClient, DeliveryItemV2Response, FlowRequest, FlowResponse, IInvoiceItemV2Response, PartResponse, ProductResponse, WorkItemV2Response, WorkV2Response) {
  'use strict';

  /**
   * The DeliveryItemV2Response model module.
   * @module model/DeliveryItemV2Response
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>DeliveryItemV2Response</code>.
   * @alias module:model/DeliveryItemV2Response
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>DeliveryItemV2Response</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DeliveryItemV2Response} obj Optional instance to populate.
   * @return {module:model/DeliveryItemV2Response} The populated <code>DeliveryItemV2Response</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('attributeSetId'))
        obj.attributeSetId = ApiClient.convertToType(data['attributeSetId'], 'String');
      if (data.hasOwnProperty('catalogueId'))
        obj.catalogueId = ApiClient.convertToType(data['catalogueId'], 'String');
      if (data.hasOwnProperty('categoryId'))
        obj.categoryId = ApiClient.convertToType(data['categoryId'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('comment'))
        obj.comment = ApiClient.convertToType(data['comment'], 'String');
      if (data.hasOwnProperty('configurableFieldList'))
        obj.configurableFieldList = ApiClient.convertToType(data['configurableFieldList'], ['String']);
      if (data.hasOwnProperty('cost'))
        obj.cost = ApiClient.convertToType(data['cost'], 'String');
      if (data.hasOwnProperty('crudlStatus'))
        obj.crudlStatus = ApiClient.convertToType(data['crudlStatus'], 'String');
      if (data.hasOwnProperty('customPropertiesJson'))
        obj.customPropertiesJson = ApiClient.convertToType(data['customPropertiesJson'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('deliveryId'))
        obj.deliveryId = ApiClient.convertToType(data['deliveryId'], 'String');
      if (data.hasOwnProperty('deliveryItemList'))
        obj.deliveryItemList = ApiClient.convertToType(data['deliveryItemList'], [DeliveryItemV2Response]);
      if (data.hasOwnProperty('endDate'))
        obj.endDate = ApiClient.convertToType(data['endDate'], 'Date');
      if (data.hasOwnProperty('entityId'))
        obj.entityId = ApiClient.convertToType(data['entityId'], 'String');
      if (data.hasOwnProperty('entityType'))
        obj.entityType = ApiClient.convertToType(data['entityType'], 'String');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('fileUrls'))
        obj.fileUrls = ApiClient.convertToType(data['fileUrls'], ['String']);
      if (data.hasOwnProperty('flowId'))
        obj.flowId = ApiClient.convertToType(data['flowId'], 'String');
      if (data.hasOwnProperty('flowItemId'))
        obj.flowItemId = ApiClient.convertToType(data['flowItemId'], 'String');
      if (data.hasOwnProperty('flowRequestList'))
        obj.flowRequestList = ApiClient.convertToType(data['flowRequestList'], [FlowRequest]);
      if (data.hasOwnProperty('flowResponseList'))
        obj.flowResponseList = ApiClient.convertToType(data['flowResponseList'], [FlowResponse]);
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('imageUrls'))
        obj.imageUrls = ApiClient.convertToType(data['imageUrls'], ['String']);
      if (data.hasOwnProperty('invoiceId'))
        obj.invoiceId = ApiClient.convertToType(data['invoiceId'], 'String');
      if (data.hasOwnProperty('invoiceItemList'))
        obj.invoiceItemList = ApiClient.convertToType(data['invoiceItemList'], [IInvoiceItemV2Response]);
      if (data.hasOwnProperty('kanbanBoardId'))
        obj.kanbanBoardId = ApiClient.convertToType(data['kanbanBoardId'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('longDescription'))
        obj.longDescription = ApiClient.convertToType(data['longDescription'], 'String');
      if (data.hasOwnProperty('manufactureTogether'))
        obj.manufactureTogether = ApiClient.convertToType(data['manufactureTogether'], 'Boolean');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('operationalType'))
        obj.operationalType = ApiClient.convertToType(data['operationalType'], 'String');
      if (data.hasOwnProperty('orderId'))
        obj.orderId = ApiClient.convertToType(data['orderId'], 'String');
      if (data.hasOwnProperty('orderItemId'))
        obj.orderItemId = ApiClient.convertToType(data['orderItemId'], 'String');
      if (data.hasOwnProperty('parentId'))
        obj.parentId = ApiClient.convertToType(data['parentId'], 'String');
      if (data.hasOwnProperty('partList'))
        obj.partList = ApiClient.convertToType(data['partList'], [PartResponse]);
      if (data.hasOwnProperty('partProductJson'))
        obj.partProductJson = ApiClient.convertToType(data['partProductJson'], 'String');
      if (data.hasOwnProperty('price'))
        obj.price = ApiClient.convertToType(data['price'], 'String');
      if (data.hasOwnProperty('productList'))
        obj.productList = ApiClient.convertToType(data['productList'], [ProductResponse]);
      if (data.hasOwnProperty('productType'))
        obj.productType = ApiClient.convertToType(data['productType'], 'String');
      if (data.hasOwnProperty('quantity'))
        obj.quantity = ApiClient.convertToType(data['quantity'], 'Number');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('sequence'))
        obj.sequence = ApiClient.convertToType(data['sequence'], 'Number');
      if (data.hasOwnProperty('shipTogether'))
        obj.shipTogether = ApiClient.convertToType(data['shipTogether'], 'Boolean');
      if (data.hasOwnProperty('shortDescription'))
        obj.shortDescription = ApiClient.convertToType(data['shortDescription'], 'String');
      if (data.hasOwnProperty('sku'))
        obj.sku = ApiClient.convertToType(data['sku'], 'String');
      if (data.hasOwnProperty('startDate'))
        obj.startDate = ApiClient.convertToType(data['startDate'], 'Date');
      if (data.hasOwnProperty('stationId'))
        obj.stationId = ApiClient.convertToType(data['stationId'], 'String');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('stockType'))
        obj.stockType = ApiClient.convertToType(data['stockType'], 'String');
      if (data.hasOwnProperty('supplierId'))
        obj.supplierId = ApiClient.convertToType(data['supplierId'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('workFlowType'))
        obj.workFlowType = ApiClient.convertToType(data['workFlowType'], 'String');
      if (data.hasOwnProperty('workId'))
        obj.workId = ApiClient.convertToType(data['workId'], 'String');
      if (data.hasOwnProperty('workItemList'))
        obj.workItemList = ApiClient.convertToType(data['workItemList'], [WorkItemV2Response]);
      if (data.hasOwnProperty('workList'))
        obj.workList = ApiClient.convertToType(data['workList'], [WorkV2Response]);
    }
    return obj;
  }

  /**
   * @member {String} attributeSetId
   */
  exports.prototype.attributeSetId = undefined;

  /**
   * @member {String} catalogueId
   */
  exports.prototype.catalogueId = undefined;

  /**
   * @member {String} categoryId
   */
  exports.prototype.categoryId = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} comment
   */
  exports.prototype.comment = undefined;

  /**
   * @member {Array.<String>} configurableFieldList
   */
  exports.prototype.configurableFieldList = undefined;

  /**
   * @member {String} cost
   */
  exports.prototype.cost = undefined;

  /**
   * @member {module:model/DeliveryItemV2Response.CrudlStatusEnum} crudlStatus
   */
  exports.prototype.crudlStatus = undefined;

  /**
   * @member {String} customPropertiesJson
   */
  exports.prototype.customPropertiesJson = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} deliveryId
   */
  exports.prototype.deliveryId = undefined;

  /**
   * @member {Array.<module:model/DeliveryItemV2Response>} deliveryItemList
   */
  exports.prototype.deliveryItemList = undefined;

  /**
   * @member {Date} endDate
   */
  exports.prototype.endDate = undefined;

  /**
   * @member {String} entityId
   */
  exports.prototype.entityId = undefined;

  /**
   * @member {String} entityType
   */
  exports.prototype.entityType = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {Array.<String>} fileUrls
   */
  exports.prototype.fileUrls = undefined;

  /**
   * @member {String} flowId
   */
  exports.prototype.flowId = undefined;

  /**
   * @member {String} flowItemId
   */
  exports.prototype.flowItemId = undefined;

  /**
   * @member {Array.<module:model/FlowRequest>} flowRequestList
   */
  exports.prototype.flowRequestList = undefined;

  /**
   * @member {Array.<module:model/FlowResponse>} flowResponseList
   */
  exports.prototype.flowResponseList = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Array.<String>} imageUrls
   */
  exports.prototype.imageUrls = undefined;

  /**
   * @member {String} invoiceId
   */
  exports.prototype.invoiceId = undefined;

  /**
   * @member {Array.<module:model/IInvoiceItemV2Response>} invoiceItemList
   */
  exports.prototype.invoiceItemList = undefined;

  /**
   * @member {String} kanbanBoardId
   */
  exports.prototype.kanbanBoardId = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} longDescription
   */
  exports.prototype.longDescription = undefined;

  /**
   * @member {Boolean} manufactureTogether
   */
  exports.prototype.manufactureTogether = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} operationalType
   */
  exports.prototype.operationalType = undefined;

  /**
   * @member {String} orderId
   */
  exports.prototype.orderId = undefined;

  /**
   * @member {String} orderItemId
   */
  exports.prototype.orderItemId = undefined;

  /**
   * @member {String} parentId
   */
  exports.prototype.parentId = undefined;

  /**
   * @member {Array.<module:model/PartResponse>} partList
   */
  exports.prototype.partList = undefined;

  /**
   * @member {String} partProductJson
   */
  exports.prototype.partProductJson = undefined;

  /**
   * @member {String} price
   */
  exports.prototype.price = undefined;

  /**
   * @member {Array.<module:model/ProductResponse>} productList
   */
  exports.prototype.productList = undefined;

  /**
   * @member {String} productType
   */
  exports.prototype.productType = undefined;

  /**
   * @member {Number} quantity
   */
  exports.prototype.quantity = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {Number} sequence
   */
  exports.prototype.sequence = undefined;

  /**
   * @member {Boolean} shipTogether
   */
  exports.prototype.shipTogether = undefined;

  /**
   * @member {String} shortDescription
   */
  exports.prototype.shortDescription = undefined;

  /**
   * @member {String} sku
   */
  exports.prototype.sku = undefined;

  /**
   * @member {Date} startDate
   */
  exports.prototype.startDate = undefined;

  /**
   * @member {String} stationId
   */
  exports.prototype.stationId = undefined;

  /**
   * @member {String} status
   */
  exports.prototype.status = undefined;

  /**
   * @member {String} stockType
   */
  exports.prototype.stockType = undefined;

  /**
   * @member {String} supplierId
   */
  exports.prototype.supplierId = undefined;

  /**
   * @member {String} type
   */
  exports.prototype.type = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {module:model/DeliveryItemV2Response.WorkFlowTypeEnum} workFlowType
   */
  exports.prototype.workFlowType = undefined;

  /**
   * @member {String} workId
   */
  exports.prototype.workId = undefined;

  /**
   * @member {Array.<module:model/WorkItemV2Response>} workItemList
   */
  exports.prototype.workItemList = undefined;

  /**
   * @member {Array.<module:model/WorkV2Response>} workList
   */
  exports.prototype.workList = undefined;


  /**
   * Allowed values for the <code>crudlStatus</code> property.
   * @enum {String}
   * @readonly
   */
  exports.CrudlStatusEnum = {
    /**
     * value: "CREATE"
     * @const
     */
    CREATE: "CREATE",

    /**
     * value: "READ"
     * @const
     */
    READ: "READ",

    /**
     * value: "UPDATE"
     * @const
     */
    UPDATE: "UPDATE",

    /**
     * value: "DELETE"
     * @const
     */
    DELETE: "DELETE",

    /**
     * value: "LIST"
     * @const
     */
    LIST: "LIST"
  };


  /**
   * Allowed values for the <code>workFlowType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.WorkFlowTypeEnum = {
    /**
     * value: "MASTER"
     * @const
     */
    MASTER: "MASTER",

    /**
     * value: "ITEM"
     * @const
     */
    ITEM: "ITEM"
  };

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/DeliveryItemV2Response.js